import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { IconButton, Snackbar as MuiSnackbar } from '@mui/material';
import Icon from '@icon-park/react/es/all';
import './Snackbar.scss';
export var SnackBarType;
(function (SnackBarType) {
    SnackBarType[SnackBarType["INFO"] = 0] = "INFO";
    SnackBarType[SnackBarType["SUCCESS"] = 1] = "SUCCESS";
    SnackBarType[SnackBarType["WARNING"] = 2] = "WARNING";
    SnackBarType[SnackBarType["ERROR"] = 3] = "ERROR";
})(SnackBarType || (SnackBarType = {}));
function Snackbar({ open = false, setOpen = () => { }, message = '', type = SnackBarType.INFO, autoHide = true, hideOnNavigate = false, history = {} }) {
    let iconType = 'info';
    let classType = 'info';
    if (type === SnackBarType.SUCCESS) {
        iconType = 'check-one';
        classType = 'success';
    }
    else if (type === SnackBarType.WARNING) {
        iconType = 'flashlamp';
        classType = 'warning';
    }
    else if (type === SnackBarType.ERROR) {
        iconType = 'close-one';
        classType = 'error';
    }
    const handleClose = (e) => {
        e && e.stopPropagation();
        e && e.preventDefault();
        setOpen(false);
    };
    useEffect(() => {
        if (hideOnNavigate) {
            setOpen(false);
        }
        // eslint-disable-next-line
    }, [history.location.pathname]);
    return (React.createElement(MuiSnackbar, { key: message, classes: {
            root: classType,
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, open: open, autoHideDuration: autoHide ? 6000 : null, onClose: handleClose, ClickAwayListenerProps: { onClickAway: () => null }, message: React.createElement(React.Fragment, null,
            React.createElement(Icon, { type: iconType, theme: "outline", size: 20 }),
            React.createElement("span", null, message)), action: React.createElement(IconButton, { disableRipple: true, size: "small", "aria-label": "close", color: "inherit", onClick: handleClose },
            React.createElement(Icon, { type: "close-small", theme: "filled", size: 20 })) }));
}
export default withRouter(Snackbar);
